import { QRCodeSVG } from 'qrcode.react';

import { Database_Procs_PrintMembershipCards_Item } from '@suntex.fim/api-client';
import { MembershipCardType } from '@suntex.fim/enums';

import './membership-cards.scss';

const paperSteps = [
  new URL('./assets/Step-1PL.png', import.meta.url).href,
  new URL('./assets/Step-2PL.png', import.meta.url).href,
  new URL('./assets/Step-3PL.png', import.meta.url).href,
  new URL('./assets/Step-4PL.png', import.meta.url).href,
];
const qrSteps = [
  new URL('./assets/Step-1QR.png', import.meta.url).href,
  new URL('./assets/Step-2QR.png', import.meta.url).href,
  new URL('./assets/Step-3QR.png', import.meta.url).href,
];
const scanIllustration = new URL('./assets/Step-barQR.png', import.meta.url)
  .href;

export interface MembershipCardsProps {
  cards: Database_Procs_PrintMembershipCards_Item[];
  cardType: MembershipCardType;
  teamName: string;
}

function LearningSteps({ isQr }: { isQr: boolean }) {
  const steps = [
    {
      title: isQr ? 'EASY LOGIN' : 'OUR WEBSITE',
      text: isQr
        ? 'Below the login area, look for the QR Code button and click it!'
        : 'Go to firstinmath',
      detail: isQr
        ? ''
        : '(If your child uses a school access portal, like CLEVER, follow their instructions)',
    },
    ...(!isQr
      ? [
          {
            title: 'LOGIN',
            text: 'Type in your FIM User ID & Password and click GO!',
            detail: '',
          },
        ]
      : []),
    {
      title: 'HOMEPAGE',
      text: 'Click an icon from your PLAYER HUB to explore what games are inside.',
      detail: '(Click the center of any Hub to go BACK)',
    },
    {
      title: 'PLAY & LEARN',
      text: 'Pick a game and play! Choose your own, or what your teacher assigns.',
      detail: "(Teachers see what you've played)",
    },
  ];

  return (
    <div className="membership-steps">
      {steps.map((step, index) => (
        <div className="membership-step" key={step.title}>
          <img src={(isQr ? qrSteps : paperSteps)[index]} alt="" />
          <h3>{step.title}</h3>
          <p>{step.text}</p>
          {step.detail && <small>{step.detail}</small>}
          {step.title === 'LOGIN' && (
            <span className="membership-arrow-down" aria-hidden="true" />
          )}
        </div>
      ))}
    </div>
  );
}

export function MembershipCards({
  cards,
  cardType,
  teamName,
}: MembershipCardsProps) {
  const isQr = cardType === MembershipCardType.QRCode;

  return (
    <div className="membership-sheets">
      {cards.map((card) => (
        <article
          key={`${card.id}-${card.userId}`}
          className={`membership-sheet membership-sheet--${isQr ? 'qr' : 'paper'}`}
        >
          {isQr && (
            <header className="membership-school">
              <span>{card.schoolName}</span>
              <span>{card.teamName || teamName}</span>
              <span>{card.className}</span>
            </header>
          )}
          <div className="membership-intro">
            <h1>Practice is {isQr ? 'the ' : ''}key to success in math!</h1>
            <p>our school is using the innovative</p>
            <h2>
              First In Math<sup>&reg;</sup> Online Program
            </h2>
            <p>
              to help {isQr ? '' : 'K-8 '}students practice and master essential
              math skills.
            </p>
          </div>
          <LearningSteps isQr={isQr} />
          {isQr ? (
            <div className="membership-scan">
              <img
                src={scanIllustration}
                alt="Find the QR Code button below the login area"
              />
              <div className="membership-scan-instructions">
                <h3>SCAN THIS QR CODE</h3>
                <p>with your device CAMERA to log in!</p>
                <span className="membership-arrow-right" aria-hidden="true" />
              </div>
              <div className="membership-qr">
                <p>
                  <strong>Team Name: </strong>
                  {card.teamName || teamName}
                </p>
                <p>
                  <strong>Display Name: </strong>
                  {card.displayName}
                </p>
                {card.qrCode && (
                  <QRCodeSVG
                    value={card.qrCode}
                    level="Q"
                    size={160}
                    fgColor="#6544e8"
                    title={`QR Code for ${card.displayName}`}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className="membership-login">
              <h2>First in math</h2>
              <dl>
                <div>
                  <dt>User ID:</dt>
                  <dd>{card.userId}</dd>
                </div>
                <div>
                  <dt>Display Name:</dt>
                  <dd>{card.displayName}</dd>
                </div>
                <div>
                  <dt>Password:</dt>
                  <dd>{card.password}</dd>
                </div>
                <div>
                  <dt>Team Name:</dt>
                  <dd>{card.teamName || teamName}</dd>
                </div>
              </dl>
            </div>
          )}
        </article>
      ))}
    </div>
  );
}
